import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

class ActiveGenerationBlockedModal extends React.Component {
    close = () => {
        dispatch.app.setActiveGenerationBlockedModal(false);
        dispatch.app.setActiveGenerationBlockedProps(null);
    }

    render() {
        const { activeGenerationBlockedModal, activeGenerationBlockedProps } = this.props;
        const userName = (activeGenerationBlockedProps && activeGenerationBlockedProps.userName) || 'A user';
        const playbookName = (activeGenerationBlockedProps && activeGenerationBlockedProps.playbookName) || 'a playbook';

        return (
            <Modal
                className="premium-resource-modal"
                open={activeGenerationBlockedModal}
                size="small"
                onClose={this.close}
                closeIcon={<Icon name="close" className="internal-close-icon" />}
            >
                <div className="modal-inner-padding">
                    <Modal.Header>
                        <div className="header-title">Playbook Generation In Progress</div>
                    </Modal.Header>

                    <Modal.Content>
                        <div className="header-subtitle">
                            One Playbook at a time can be generated for this account.  
                        </div>

                        <div className="renewal-infobox">
                            <div className="renewal-icon">
                                <Icon name="clock outline" />
                            </div>
                            <div className="renewal-text">
                                <strong>{userName}</strong> is currently generating the playbook{' '}
                                <strong>&ldquo;{playbookName}&rdquo;</strong>. Please wait for it to complete before
                                starting a new generation.
                            </div>
                        </div>
                    </Modal.Content>
                </div>
                <Modal.Actions className="modal-footer-actions">
                    <Button className="button-submit" size="tiny" onClick={this.close}>
                        Okay
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default ActiveGenerationBlockedModal;
